const classmap = {
  item: '[data-step-item]',
  a11y: '[data-a11y]'
}

const mount = () => {
  document.addEventListener('step-on-show', ({ target }) => {
    const bubblingTarget = target.closest(classmap.item)
    if (!bubblingTarget) return

    const title = bubblingTarget.querySelector(classmap.a11y)
    if (!title) return

    title.setAttribute('tabindex', '-1')
    title.focus()
  })
}

export default { mount }
